import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s3/b1.jpg');

class Services_3 extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        title="Reliable Pressure. Precise Response. Proven Protection."
                        pagename="Hydrant & Sprinkler System Care"
                        bgimage={bnrimg}
                    />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="blog-single-wrap-width">
                                <div className="blog-post date-style-3 blog-detail text-black">
                                    <div className="mt-post-media clearfix m-b30">
                                        <ul className="grid-post">
                                            <li>
                                                <div className="portfolio-item">
                                                    <img
                                                        className="img-responsive"
                                                        src={require("./../../images/s3/b2.jpg")}
                                                        alt="Hydrant and Sprinkler System"
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="mt-post-title">
                                        <h3 className="post-title font-weight-600">
                                            Hydrant & Sprinkler System Care
                                        </h3>
                                    </div>

                                    <div className="mt-post-text">
                                        <p><strong>"Water is your first responder. Let it never fail."</strong></p>

                                        <p>
                                            At <strong>I-Smart Engineering Works</strong>, we ensure your fire hydrant and sprinkler systems are always mission-ready. These systems are not just pipes and valves — they are precision-engineered networks designed to deliver immediate suppression power during fire emergencies.
                                        </p>

                                        <p>
                                            Backed by military-inspired discipline and standards, our team provides complete inspection, maintenance, and system upgrades for both wet and dry sprinkler systems, as well as hydrant pipelines and boosters — ensuring pressure, reach, and reliability when seconds matter.
                                        </p>

                                        <h4 className="font-weight-600">Our Hydrant & Sprinkler Services Include:</h4>
                                        <ul className="list-angle-right">
                                            <li>Routine maintenance and pressure testing</li>
                                            <li>Cleaning and flushing of pipelines</li>
                                            <li>Sprinkler head checks and nozzle alignment</li>
                                            <li>Pump room evaluation and upgrades</li>
                                            <li>Comprehensive AMC support with 24/7 fault response</li>
                                        </ul>

                                        <blockquote className="bg-dark text-white author-quote">
                                            <h4 className="m-b0">
                                                “In the Navy, we train systems to work under pressure—literally. Civil safety demands the same precision.” <i className="fa fa-quote-right" />
                                            </h4>
                                            <div className="p-t15 text-white">
                                                <strong className="text-primary">Commander R. Hayes</strong>
                                                <span>U.S. Naval Safety Division</span>
                                            </div>
                                        </blockquote>

                                        <p>
                                            From industrial zones to high-rises, our fire water systems have protected life and property through consistent performance and scheduled care. Every hydrant we test and every sprinkler we align is part of our silent defense against fire hazards.
                                        </p>

                                        {/* <div className="row">
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog.jpg")}
                                                            alt="Hydrant Testing"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog2.jpg")}
                                                            alt="Sprinkler System Inspection"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog3.jpg")}
                                                            alt="Pump Room Check"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <p>
                                            <strong>Let water do its job — we’ll make sure it’s ready.</strong> Talk to us for a no-cost audit and hydrant/sprinkler health report tailored to your property.
                                        </p>
                                    </div>

                                    <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="widget widget_tag_cloud">
                                                    <h4 className="tagcloud">Tags</h4>
                                                    <div className="tagcloud">
                                                        <NavLink to={"#"}>Hydrant Maintenance</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Sprinkler Inspection</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Fire Safety Systems</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Water Pressure Testing</NavLink>&nbsp;
                                                        <NavLink to={"#"}>AMC Services</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default Services_3;
